// InputFormik.tsx

/* eslint-disable react-hooks/exhaustive-deps */


import { useFormikContext, getIn } from 'formik';
import { pluck } from '../../helpers/pluck';
import { useCallback, useEffect, useMemo, useState } from 'react';

type InputFormikProps = {
  name: string;
  type?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  className?: string;
  label?: string;
  required?: boolean;
  readonly?: boolean;
  mask?: (input: string) => string;
  value?: unknown;
  defaultValue?: unknown;
  min?: string;
  max?: string;
  step?: string;
  actionButton?: React.ReactNode;
};

const InputFormik: React.FC<InputFormikProps> = ({ name, type, placeholder, onChange, onBlur, className, label, required, readonly, mask, defaultValue, min, max, step, actionButton }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const data = getIn(values, name)
  const theMask = useCallback((input: string) => mask ? mask(input) : input, [mask])

  const [value, setValue] = useState(theMask(data))
  const theError = useMemo(() => pluck(name, errors) || undefined, [errors, name])

  useEffect(() => {
    const maskedValue = theMask(data)
    if (maskedValue !== value) {
      setValue(theMask(data))
    }
  }, [data])

  useEffect(() => {
    const maskedValue = theMask(data)
    if (maskedValue !== data) {
      setFieldValue(name, maskedValue)
    }
  }, [name, setFieldValue, value])

  useEffect(() => {
    if (defaultValue && !data) {
      setFieldValue(name, defaultValue)
      return;
    }
    setFieldValue(name, value)

  }, [name, setFieldValue, value])

  const applyHandleChange = useCallback((e) => {
    const maskedValue = theMask(e.target.value)
    setValue(maskedValue)
    onChange && onChange(e)
  }, [theMask])

  return (
    <div className={`text-[16px] ${className}`}>
      <label htmlFor={name} className="block font-medium text-[16px] text-gray-600">{label} {required ? <b className="text-redPrimary">*</b> : ''}</label>
      <div className='flex items-center gap-2'>
        <input
          id={name}
          type={type ?? 'text'}
          onWheel={(e) => (e.target as HTMLInputElement).blur()} // Corrige o tipo de e.target
          placeholder={placeholder || ''}
          onChange={applyHandleChange}
          onBlur={onBlur}
          value={value}
          className={`border checked:bg-red-600 border-gray h-[35px] text-gray2 p-2 rounded w-full bg-[#ffffff]  ${type === 'date' ? 'input-date ' : ''}`}
          style={{ colorScheme: "dark" }}
          aria-required={required}
          aria-invalid={Boolean(pluck(name, errors))}
          readOnly={readonly}
          min={min}
          max={max}
          step={step}
        />
        {actionButton}
      </div>
      {theError ? <small className="text-redPrimary/90" aria-live="polite">{theError}</small> : null}
    </div>
  );
};

export default InputFormik;
